/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, March 29th 2022, 5:32:58 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import ListItemText from "@mui/material/ListItemText";
import {
  APIMany2OneSelectFormInput,
  ConcreteAPIMany2OneSelectFormInputProps,
  APIMany2ManyTransferListFormInput,
} from "ui-widgets";
import { ProcessDefinition, TaskTemplate } from "lib/schemas";
import { APISERVICEPATHS } from "lib/api";
import { TConnectedNodesDirection } from "lib/schemas/service-builder/types";
import { PrimaryKeyValue } from "lib/types";
import { ClipboardIcon } from "theme/icons";
import { COLORSCHEME } from "theme/styles";

type APITaskTemplateFilters = {
  process_definition?: number & PrimaryKeyValue<ProcessDefinition>;
  exclude?: TaskTemplate["id"][];
  connected_process_tasks_inclusion?: TConnectedNodesDirection;
} & Partial<
  Omit<
    TaskTemplate,
    | "extra_data"
    | "outgoing_branches"
    | "settings_for_undone_state_preservation"
    | "boundary_events_detailed"
    | "event_type"
  >
>;

interface TaskTemplateInputProps<PrimaryObject>
  extends ConcreteAPIMany2OneSelectFormInputProps<PrimaryObject, TaskTemplate> {
  apiQueryParams?: APITaskTemplateFilters;
  getOptionLabel?: (option: TaskTemplate) => string;
}

export const TaskTemplateInput = <PrimaryObject,>(props: TaskTemplateInputProps<PrimaryObject>) => {
  return (
    <APIMany2OneSelectFormInput<PrimaryObject, TaskTemplate>
      label={props.label ?? "Task Template"}
      itemIdProperty="id"
      getOptionLabel={(option) => option.title}
      loadingText="Loading Task Templates"
      apiServicePath={APISERVICEPATHS.taskDefinitions}
      inputStartAdornment={<ClipboardIcon fill={COLORSCHEME.primary} width={24} height={24} />}
      {...props}
    />
  );
};

export const TaskTemplatesTransferListInput = <PrimaryObject,>(props: TaskTemplateInputProps<PrimaryObject>) => (
  <APIMany2ManyTransferListFormInput<PrimaryObject, TaskTemplate>
    itemIdProperty="id"
    getOptionLabel={(option) => <ListItemText primary={`${option.title}`} />}
    apiServicePath={APISERVICEPATHS.taskDefinitions}
    {...props}
  />
);
